<div class="active-filters">
    <ng-container *ngFor="let key of formKeys">
        <ng-container [ngSwitch]="key">
            <ng-container *ngIf="queryId">
                <div class="applied-filter" *ngSwitchCase="'queryId'">
                    <span class="filter-name">{{ "MY_REQUESTS.IDENTIFIER" | translate }}</span>
                    <span class="filter-value">{{ queryId }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'startDate'">
                    <span class="filter-name">{{'FILTER.FROM' | translate }}</span>
                    <span class="filter-value">{{ getFormControlObject(key).value | date: 'dd/MM/yyy' }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'endDate'">
                    <span class="filter-name">{{ 'FILTER.TO' | translate }}</span>
                    <span class="filter-value">{{ getFormControlObject(key).value | date: 'dd/MM/yyy' }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'queryType'">
                    <span class="filter-name">{{ "MY_REQUESTS.TYPE" | translate }}</span>
                    <span class="filter-value">{{ innovationRequestService.getQueryTypeTitle(getFormControlObject(key).value) | translate }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="personId">
                <div class="applied-filter" *ngSwitchCase="'personId'">
                    <span class="filter-name">{{ "MY_REQUESTS.TIN" | translate }}</span>
                    <span class="filter-value">{{ personId }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="firstName">
                <div class="applied-filter" *ngSwitchCase="'firstName'">
                    <span class="filter-name">{{ "MY_REQUESTS.NAME_OR_LEGAL_NAME" | translate }}</span>
                    <span class="filter-value">{{ firstName }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <!-- <ng-container *ngIf="email">
                <div class="applied-filter" *ngSwitchCase="'email'">
                    <span class="filter-name">{{ "MY_REQUESTS.EMAIL" | translate }}</span>
                    <span class="filter-value">{{ email }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container> -->

            <ng-container *ngIf="phoneNumber">
                <div class="applied-filter" *ngSwitchCase="'phoneNumber'">
                    <span class="filter-name">{{ "MY_REQUESTS.PHONE" | translate }}</span>
                    <span class="filter-value">{{ phoneNumber }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'personType'">
                    <span class="filter-name">{{ "MY_REQUESTS.LABORAL_REGIME" | translate }}</span>
                    <span class="filter-value">{{ innovationRequestService.getPersonTypeTitle(getFormControlObject(key).value) | translate}}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'status'">
                    <span class="filter-name">{{ "MY_REQUESTS.STATUS" | translate }}</span>
                    <span class="filter-value">{{ innovationRequestService.getRequestStatusTitle(getFormControlObject(key).value) | translate }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="getFormControlObject(key).value">
                <div class="applied-filter" *ngSwitchCase="'substatus'">
                    <span class="filter-name">{{ 'MY_REQUESTS.SUBSTATUS' | translate }}</span>
                    <span class="filter-value">{{ getFormControlObject(key).value }}</span>
                    <button class="clear-filter" (click)="clearFilter(key)">
                        <span class="material-symbols-outlined"> cancel </span>
                    </button>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="innovationRequestsFilterService.query !== '' && innovationRequestsFilterService.query !== null">
        <div class="applied-filter">
            <span class="filter-name">{{ "FILTER.STRING_QUERY" | translate }}</span>
            <span class="filter-value">{{ innovationRequestsFilterService.query }}</span>
            <button class="clear-filter" (click)="innovationRequestsFilterService.clearGlobalSearch()">
                <span class="material-symbols-outlined"> cancel </span>
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="thereIsMoreThanOneFilterActive()">
        <button class="btn-clean-filters" (click)="clearAllFiltersAndGlobalSearch()">
            <span class="material-symbols-outlined"> filter_alt_off </span>
            {{ "FILTER.CLEAN_ALL" | translate }}
        </button>
    </ng-container>
</div>
